<template>
    <div class="header-box">
        <div class="header">
            <span class="colorspan">{{ titleName }}</span>
        </div>
        <div class="table-content">
            <table border="1">
                <tr>
                    <th colspan="4">基本信息</th>
                </tr>
                <tr>
                    <th>项目名称</th>
                    <td colspan="3">
                        <input v-model="dataInfo.projectName" type="text"/>
                    </td>
                </tr>
                <tr>
                    <th>项目年度</th>
                    <td><input v-model="dataInfo.projectYear" readonly type="text"/></td>
                    <th>资助类别</th>
                    <td style="width: 554px">
                        <input v-model="dataInfo.subsidizeType" readonly type="text"/>
<!--                        <select
                            v-model="dataInfo.subsidizeType"
                            placeholder="请选择"
                            @change="handleChange"
                        >
                            <option
                                v-for="(item, i) in subsidizeList"
                                :key="i"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>-->
                    </td>
                </tr>
                <tr>
                    <th>申报单位</th>
                    <td><input v-model="dataInfo.unitName" type="text"/></td>
                    <th>统一社会信用代码</th>
                    <td><input v-model="dataInfo.creditCode" type="text"/></td>
                </tr>
                <tr>
                    <th>单位类别</th>
                    <td style="width: 554px">
                        <select
                            v-model="dataInfo.unitType"
                            placeholder="请选择"
                            @change="handleChange"
                        >
                            <option
                                v-for="(item, i) in declarationList"
                                :key="i"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </td>

                    <th>合作单位</th>
                    <td style="display: flex;">

                        <table border="1">
                            <thead>
                            <tr>
                                <th style="width: 100px">序号</th>
                                <th>单位名称</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in dataInfo.cooperativeUnit" :key="index">
                                <td><input v-model="item.id" disabled type="text"/></td>
                                <td><input v-model="item.name" type="text"/></td>

                            </tr>
                            </tbody>
                        </table>


                    </td>
                </tr>
                <tr>
                    <th>项目负责人</th>
                    <td><input v-model="dataInfo.projectLeader" type="text"/></td>
                    <th>联系电话</th>
                    <td><input v-model="dataInfo.projectLeaderPhone" type="text"/></td>
                </tr>
                <tr>
                    <th>财务账号名称</th>
                    <td><input v-model="dataInfo.financeAccount" type="text"/></td>
                    <th>开户行及账号</th>
                    <td><input v-model="dataInfo.financeBankAddress" type="text"/></td>
                </tr>
                <tr>
                    <th colspan="4">项目信息</th>
                </tr>
                <tr>
                    <th>项目类别</th>
                    <td colspan="3">
                        <select
                            v-model="dataInfo.projectType"
                            placeholder="请选择"
                            @change="handleChange"
                        >
                            <option
                                v-for="(item, i) in projectTypeList"
                                :key="i"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <th>项目呈现形式</th>
                    <td colspan="3">
            <textarea
                id="contactus"
                v-model="dataInfo.projectForm"
                :placeholder="
                dataInfo.projectType == '普及活动类'
                  ? '包括但不限于演讲比赛、主题征文、知识竞赛、社科成果展示、社科书市、图书出版、读书班、文化交流考察等）；系列主题讲座或讲坛；社科文艺展演。'
                  : dataInfo.projectType == '新媒体传播类'
                  ? '包括但不限于制作社科普及短视频、微讲座，建设社科普及网站、APP、微信公众号'
                  : dataInfo.projectType == '普及成果类'
                  ? '包括但不限于社科普及手册和社科普及文创产品、普及读物'
                  : dataInfo.projectType == '普及服务类'
                  ? '包括但不限于法律援助咨询、生态环保普及、科学防疫普及、心理健康普及'
                  : ''
              "
                cols="50"
                name="contactus"
                rows="11"
                style="height: 150px"
            ></textarea>
                    </td>
                </tr>
                <tr>
                    <th>策划来源</th>
                    <td colspan="3">
                        <select
                            v-model="dataInfo.planSource"
                            placeholder="请选择"
                            @change="handleChange"
                        >
                            <option
                                v-for="(item, i) in planningSourceList"
                                :key="i"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                    </td>
                </tr>
                <tr>
                    <th>项目开展时间</th>
                    <td style="width: 554px">
                        <input v-model="dataInfo.setupTime" type="text"/>
                    </td>

                    <th>
                        <div>配套经费</div>
                        <div>(是否已获得本单位或本地区配套经费支持)</div>
                    </th>
                    <td style="width: 554px">
                        <select
                            v-model="dataInfo.isFundsSource"
                            placeholder="请选择"
                            @change="handleChange"
                        >
                            <option
                                v-for="(item, i) in appropriationList"
                                :key="i"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                        <input
                            v-if="dataInfo.isFundsSource == '是'"
                            v-model="dataInfo.fundsSource"
                            placeholder="配套金额(万元)"
                            type="text"
                        />
                    </td>
                </tr>
                <tr>
                    <th>活动受众人群</th>
                    <td style="width: 554px">
                        <select
                            v-model="dataInfo.activityPersonExtra"
                            placeholder="请选择"
                            @change="handleChange"
                        >
                            <option
                                v-for="(item, i) in audienceList"
                                :key="i"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                        <input
                            v-if="dataInfo.activityPersonExtra == '其他'"
                            v-model="dataInfo.specificPopulation"
                            placeholder="请填写具体人群"
                            type="text"
                        />
                    </td>

                    <th>受众人数(千)</th>
                    <td>
                        <input
                            v-model="dataInfo.personNumber"
                            :style="
                dataInfo.activityPersonExtra == '其他' ? 'height:80px' : '40px'
              "
                            type="text"
                        />
                    </td>
                </tr>
                <tr>
                    <th>是否已成为可持续性项目</th>
                    <td colspan="3">
                        <select
                            v-model="dataInfo.continuousContent"
                            placeholder="请选择"
                            @change="handleChange"
                        >
                            <option
                                v-for="(item, i) in sustainableList"
                                :key="i"
                                :value="item.value"
                            >
                                {{ item.name }}
                            </option>
                        </select>
                        <textarea
                            v-if="dataInfo.continuousContent == '是'"
                            id="contactus"
                            v-model="dataInfo.supplementaryMaterial"
                            cols="50"
                            name="contactus"
                            placeholder="填写前期成果与社会影响，并在最后上传前期成果与社会影响的佐证材料"
                            rows="11"
                        ></textarea>
                    </td>
                </tr>
                <tr>
                    <th>申请单位概况（限300字以内)</th>
                    <td colspan="3">
            <textarea
                id="contactus"
                v-model="dataInfo.introduction"
                cols="50"
                maxlength="300"
                name="contactus"
                placeholder="（对照申报通知中对品牌项目的有关要求，介绍申请方基本情况，以往举办过的社科普及活动情况）"
                rows="11"
            ></textarea>
                    </td>
                </tr>
                <tr>
                    <th>项目立项依据（限300字以内）</th>
                    <td colspan="3">
            <textarea
                id="innovation"
                v-model="dataInfo.innovation"
                cols="50"
                maxlength="300"
                name="innovation"
                rows="11"
            ></textarea>
                    </td>
                </tr>
                <tr>
                    <th>项目简介（限500字以内）</th>
                    <td colspan="3">
            <textarea
                id="projectBrief"
                v-model="dataInfo.projectBrief"
                cols="50"
                maxlength="500"
                name="projectBrief"
                placeholder="（基本内容：包括策划背景、开展形式，普及特色，重点突出通过项目建设打造品牌形成的平台载体）"
                rows="11"
            ></textarea>
                    </td>
                </tr>
                <tr>
                    <th>项目预期目标（限300字以内）</th>
                    <td colspan="3">
            <textarea
                id="target"
                v-model="dataInfo.target"
                cols="50"
                maxlength="300"
                name="target"
                rows="11"
            ></textarea>
                    </td>
                </tr>


                <tr>
                    <th>项目实施进度计划</th>
                    <td colspan="3">
                        <table border="1">
                            <thead>
                            <tr>
                                <th>项目实施内容</th>
                                <th>开始时间</th>
                                <th>完成时间</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in dataInfo.progressPlan" :key="index">
                                <td><input v-model="item.content" type="text"/></td>
                                <td><input v-model="item.startTime" type="text"/></td>
                                <td><input v-model="item.endTime" type="text"/></td>

                            </tr>
                            </tbody>
                        </table>
                        <div class="operation-box-bottom">
                            <a-icon theme="filled" type="plus-circle" @click="changeProgressPlan(1)"/>
                            <a-icon type="minus-circle" @click="changeProgressPlan(0)"/>
                        </div>
                    </td>

                </tr>
                <tr>
                    <th>具体预算此处填写申报经费的明细（品牌项目5万元，配套经费不体现在本表中）</th>
                    <td colspan="3">
                        <table border="1">
                            <thead>
                            <tr>
                                <th style="width: 100px">序号</th>
                                <th>经费开支科目</th>
                                <th>金 额（万元）</th>
                                <th>详细用途及说明</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(item, index) in dataInfo.budgetDetail" :key="index">
                                <td><input v-model="item.id" disabled type="text"/></td>
                                <td><input v-model="item.spending" type="text"/></td>
                                <td><input v-model="item.money" type="text"/></td>
                                <td><input v-model="item.purpose" type="text"/></td>

                            </tr>
                            </tbody>
                        </table>
                        <div class="operation-box-bottom">
                            <a-icon theme="filled" type="plus-circle" @click="changeBudgetDetail(1)"/>
                            <a-icon type="minus-circle" @click="changeBudgetDetail(0)"/>
                        </div>
                    </td>
                </tr>

            </table>
        </div>


        <a-spin :spinning="spinning" tip="上传中">
            <div v-if="dataInfo.continuousContent == '是'" class="upload">
                <p>
                    前期成果与影响佐证材料（请上传PDF、JPG格式的文件，限制5个，最大不超过5M）
                </p>
                <a-upload
                    :customRequest="uploaderCoverUrlOne"
                    :show-upload-list="false"
                    accept=".pdf, .jpg"
                >
                    <a-button
                        v-if="saveStatus == 0 || declareStatus == 0"
                        style="margin-top: 10px"
                    >
                        <a-icon type="upload"/>
                        本地上传
                    </a-button>
                    <a-button
                        v-if="
              userTypeValue == 'declarator' &&
              routerKey.indexOf('declarationCenter') > -1 &&
              (declareStatus == 2 || declareStatus == 3) &&
              newToTarget == 'declarator'
            "
                        style="margin-top: 10px"
                    >
                        <a-icon type="upload"/>
                        本地上传
                    </a-button>
                    <a-button
                        v-if="
              userTypeValue == 'cityAdm' &&
              routerKey.indexOf('declarationCenter') > -1 &&
              (declareStatus == 3) &&
              newToTarget == 'cityAdm'
            "
                        style="margin-top: 10px"
                    >
                        <a-icon type="upload"/>
                        本地上传
                    </a-button>
                </a-upload>
                <div v-if="dataInfo.fileList && dataInfo.fileList.length > 0">
                    <div
                        v-for="(item, index) in dataInfo.fileList"
                        :key="index"
                        class="file"
                    >
                        <p style="cursor: pointer" @click="preview(item)">
                            {{ item.name }}
                        </p>
                        <a-icon
                            v-if="saveStatus == 0 || declareStatus == 0"
                            type="close"
                            @click="removeFile(item, index)"
                        />
                        <a-icon
                            v-if="
               ( userTypeValue == 'declarator') &&
                routerKey.indexOf('declarationCenter') > -1 &&
                (declareStatus == 2 || declareStatus == 3) &&
                newToTarget == 'declarator'
              "
                            type="close"
                            @click="removeFile(item, index)"
                        />
                        <a-icon
                            v-if="
               ( userTypeValue == 'cityAdm') &&
                routerKey.indexOf('declarationCenter') > -1 &&
                ( declareStatus == 3) &&
                newToTarget == 'cityAdm'
              "
                            type="close"
                            @click="removeFile(item, index)"
                        />
                    </div>
                </div>
            </div>
        </a-spin>
        <div v-if="chooseType == 1 || chooseType == 2" class="radio">
            <p>市级意见：</p>
            <a-radio-group v-model="dataInfo.cityOpinion" name="radioGroup">
                <a-radio value="推荐">推荐</a-radio>
                <a-radio value="不推荐">不推荐</a-radio>
            </a-radio-group>
        </div>
        <div
            v-if="userTypeValue == 'expert'"
            class="radio"
            style="margin-top: 10px"
        >
            <p>专家评审：</p>
            <a-radio-group v-model="dataInfo.expertOpinion" name="radioGroup">
                <a-radio value="推荐">推荐</a-radio>
                <a-radio value="不推荐">不推荐</a-radio>
            </a-radio-group>
        </div>
        <div class="footer">
            <a-button
                v-if="
          (saveStatus == 0 || declareStatus == 0) && userTypeValue != 'expert'
        "
                type="primary"
                @click="save(0)"
            >保存草稿
            </a-button
            >
            <a-button
                v-if="
          (saveStatus == 0 || declareStatus == 0) && userTypeValue != 'expert'
        "
                type="primary"
                @click="save(1)"
            >提交
            </a-button
            >
            <a-button
                v-if="
          userTypeValue == 'declarator' &&
          routerKey.indexOf('declarationCenter') > -1 &&
          (declareStatus == 2 || declareStatus == 3) &&
          newToTarget == 'declarator'
        "
                type="primary"
                @click="save(0)"
            >保存草稿
            </a-button
            >
            <a-button
                v-if="
          userTypeValue == 'cityAdm' &&
          routerKey.indexOf('declarationCenter') > -1 &&
          (declareStatus == 2 || declareStatus == 3)
        "
                type="primary"
                @click="save(0)"
            >保存草稿
            </a-button
            >
            <a-button
                v-if="
          userTypeValue == 'declarator' &&
          routerKey.indexOf('declarationCenter') > -1 &&
          (declareStatus == 2 || declareStatus == 3) &&
          newToTarget == 'declarator'
        "
                type="primary"
                @click="save(1)"
            >提交
            </a-button
            >
            <a-button
                v-if="
          userTypeValue == 'cityAdm' &&
          routerKey.indexOf('declarationCenter') > -1 &&
          (declareStatus == 2 || declareStatus == 3)
        "
                type="primary"
                @click="save(1)"
            >提交
            </a-button
            >

            <a-button
                v-if="userTypeValue == 'expert' &&
        (declareStatus !=1 && saveStatus !=1)
        "
                type="primary"
                @click="saveExpertOpinion"
            >保存
            </a-button
            >
            <!-- <a-button
              type="primary"
              @click="saveExpertOpinion"
              v-if="userTypeValue == 'expert' &&
              (declareStatus ==1 && saveStatus ==1)
              "
              >保存1</a-button
            > -->
            <!-- <a-button
              type="primary"
              @click="save(1)"
              v-if="
                userTypeValue == 'declarator' &&
                (declareStatus == 2 || declareStatus == 3) &&
                (toTarget == 'declarator' || toTarget == undefined)
              "
              >提交</a-button
            > -->
            <!-- <a-button
              type="primary"
              @click="save(0)"
              v-if="
                userTypeValue == 'cityAdm' &&
                (declareStatus == 2 || declareStatus == 3) &&
                (toTarget == 'declarator' || toTarget == undefined)
              "
              >保存草稿</a-button
            > -->
            <!-- <a-button
              type="primary"
              @click="save(1)"
              v-if="
                userTypeValue == 'cityAdm' &&
                declareStatus == 3 &&
                toTarget == 'cityAdm'
              "
              >提交</a-button
            > -->
            <!-- 市级保存按钮 -->
            <a-button v-if="toTarget == 'cityAdm'" type="primary" @click="save(1)"
            >保存
            </a-button
            >
            <a-button
                v-if="
          (declareStatus == 0 || declareStatus == 3 || declareStatus == 5) &&
          saveStatus != 0 &&
          toTarget == 'declarator'
        "
                type="primary"
                @click="save(1)"
            >提交
            </a-button
            >
            <a-button @click="cancel">返回</a-button>
        </div>
    </div>
</template>

<script>
import {createdecInformationApi, decUserAccessUpdateApi, openUploadApi, updateDecInformationApi,} from "@/api/declare";
import {
    appropriationList,
    audienceList,
    declarationList,
    planningSourceList,
    projectTypeList,
    subsidizeList,
    sustainableList,
} from '@/plugins/optionList'

export default {
    components: {},
    props: {
        chooseType: {
            type: Number,
            default: 0,
        },
         toTarget: {
             type: String,
         },
    },
    data() {
        return {
            toTarget: "",
            newToTarget: "",
            userTypeValue: "",
            saveStatus: 0,
            declareStatus: 0,
            routerKey: "",
            spinning: false,
            fileUrl: "",
            titleName: "社科普及资助特色品牌项目申报",
            dataInfo: {
                // 预算明细
                budgetDetail: [
                    {
                        id: 1,
                        spending: "",
                        money: "",
                        purpose: '',
                    },
                    {
                        id: 2,
                        spending: "",
                        money: "",
                        purpose: '',
                    },
                    {
                        id: 3,
                        spending: "",
                        money: "",
                        purpose: '',
                    },
                    {
                        id: 4,
                        spending: "",
                        money: "",
                        purpose: '',
                    },
                    {
                        id: 5,
                        spending: "",
                        money: "",
                        purpose: '',
                    },
                    {
                        id: 6,
                        spending: "",
                        money: "",
                        purpose: '',
                    },
                ],
                // 项目实施进度计划
                progressPlan: [
                    {
                        content: '',
                        startTime: '',
                        endTime: '',
                    },
                    {
                        content: '',
                        startTime: '',
                        endTime: '',
                    },
                    {
                        content: '',
                        startTime: '',
                        endTime: '',
                    },
                    {
                        content: '',
                        startTime: '',
                        endTime: '',
                    },
                    {
                        content: '',
                        startTime: '',
                        endTime: '',
                    },
                ],
                // 协作单位
                cooperativeUnit: [
                    {
                        id: 1,
                        name: ''
                    },
                    {
                        id: 2,
                        name: ''
                    },
                    {
                        id: 3,
                        name: ''
                    },
                    {
                        id: 4,
                        name: ''
                    },
                ],
                projectName: "" /* 项目名称 */,
                projectYear: "2024",//项目年度

                subsidizeType: "特色品牌项目" /* 资助类别 */,
                creditCode: "",//统一社会信用代码
                decEntrance: "",
                unitName: "", // 申报单位
                unitType: "", // 单位类别
                setupTime: "", // 项目开展时间
                projectLeader: "", // 项目负责人
                financeAccount: "", //财务账号名称
                financeBankAddress: "", // 开户行及账号
                projectForm: "", // 项目呈现形式
                projectLeaderPhone: "", // 联系电话

                introduction: "", // 申请单位概况（限300字以内)
                innovation: "", // 项目立项依据
                projectBrief: "", // 项目简介
                target: "", // 项目预期目标
                personNumber: "", // 受众人数(千)
                projectType: "" /* 项目类别 */,

                fundsSource: "" /* 是否已获得本单位或本地区配套经费支持 */,
                isFundsSource: "" /*  经费金额 */,
                planSource: "" /* 策划来源 */,
                activityPersonExtra: "" /* 受众人群 */,
                specificPopulation: "", // 其他受众人群
                continuousContent: "" /* 是否可持续 */,
                supplementaryMaterial: "", // 填写和上传前期成果与影响佐证材料
                cityOpinion: "" /* 市级意见 */,
                expertOpinion: "",
                provinceOpinion: "" /* 省级意见 */,
                fileList: [],
            },
            declarationList: declarationList,
            sustainableList: sustainableList,
            audienceList: audienceList,
            projectTypeList: projectTypeList,
            planningSourceList: planningSourceList,
            appropriationList: appropriationList,
            subsidizeList: subsidizeList,
        };
    },
    methods: {

        // 项目进度 删除添加 0 删除  1添加
        changeProgressPlan(type) {
            if (type) {
                this.dataInfo.progressPlan.push({
                    content: '',
                    startTime: '',
                    endTime: '',
                },)
            } else {
                if (this.dataInfo.progressPlan.length < 6) return
                this.dataInfo.progressPlan.splice(this.dataInfo.progressPlan.length - 1, 1)
            }
        },
        // 预算明细 删除添加 0 删除  1添加
        changeBudgetDetail(type) {
            if (type) {
                this.dataInfo.budgetDetail.push({
                    id: this.dataInfo.budgetDetail.length + 1,
                    spending: "",
                    money: "",
                    purpose: '',
                })
            } else {
                if (this.dataInfo.budgetDetail.length < 5) return
                this.dataInfo.budgetDetail.splice(this.dataInfo.budgetDetail.length - 1, 1)
            }
        },
        //
        createdecInformation(i) {
            let obj = JSON.parse(localStorage.getItem("userModel"));
            console.log(this.dataInfo);
            let params = {
                baseType: '2', // 品牌项目
                extraInfo: JSON.stringify(this.dataInfo),
                type: 0,
                fromSource: obj.userType,
                status: i,
                decEntrance: this.dataInfo.decEntrance,
                secondaryDecEntrance: obj.secondaryDecEntrance,
                // filePath: this.fileUrl,
                projectName: this.dataInfo.projectName,
                projectType: this.dataInfo.projectType,
                projectYear: this.dataInfo.projectYear,
                unitName: this.dataInfo.unitName,
                unitType: this.dataInfo.unitType,
                cityOpinion: "", //之前的市审核员审核意见要清空
                provinceOpinion: "", //之前的省审核员审核意见要清空
            };
            if (this.userTypeValue == "declarator") {
                params.toTarget = "cityAdm";
                params.level = 0;
            } else if (this.userTypeValue == "cityAdm") {
                params.toTarget = "provinceAdm";
                params.level = 1;
            }
            if (this.toTarget == "cityAdm") {
                if (this.dataInfo.cityOpinion == "") {
                    this.$message.warn("市级意见不能为空");
                    return;
                }
                params.cityOpinion = this.dataInfo.cityOpinion;
            }
            if (
                this.dataInfo.decEntrance == "省属机关" ||
                this.dataInfo.decEntrance == "省属学会" ||
                this.dataInfo.decEntrance == "省属企业"
            ) {
                params.toTarget = "provinceAdm";
                params.level = 1;
            }
            // 保存草稿
            // if (i == 0) {
            //   params.toTarget = "declarator";
            // }
            if (sessionStorage.getItem("declareInfo")) {
                let declareInfoObj = JSON.parse(sessionStorage.getItem("declareInfo"));
                params.id = declareInfoObj.id;
                delete params.level;
                //基地申报不需要给cityCheckUid参数，并且修改时之前的市审核员审核意见要清空
                if (this.userTypeValue == "cityAdm") {
                    params.cityCheckUid = obj.productUserId;
                } else {
                    params.cityCheckUid = 0;
                }
                params.cityEvaluation = ""; //修改清除市评分
                params.secondaryDecEntrance = declareInfoObj.secondaryDecEntrance
                if (params.decEntrance !== '部属、省属高校') {
                    params.secondaryDecEntrance = ""
                }
                updateDecInformationApi(params).then((res) => {
                    if (res.status) {
                        this.$message.success(res.message);
                        setTimeout(() => {
                            this.$emit("backProject", this.chooseType);
                        }, 1000);
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                params.createUid = obj.productUserId;
                if (params.decEntrance !== '部属、省属高校') {
                    params.secondaryDecEntrance = ""
                }
                createdecInformationApi(params).then((res) => {
                    if (res.status) {
                        this.$message.success(res.message);
                        setTimeout(() => {
                            this.$emit("backProject");
                        }, 1000);
                    } else {
                        this.$message.error(res.message);
                    }
                });
            }
        },
        saveExpertOpinion() {
            if (this.dataInfo.expertOpinion == "") {
                this.$message.warn("请进行评审");
                return;
            }
            let declareInfoObj = JSON.parse(sessionStorage.getItem("declareInfo"));
            let params = {
                id: declareInfoObj.checkRecordId,
                expertOpinion: this.dataInfo.expertOpinion,
            };
            decUserAccessUpdateApi(params).then((res) => {
                if (res.status) {
                    this.$message.success(res.message);
                    setTimeout(() => {
                        this.$emit("backProject");
                    }, 1000);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        removeEmptyObjectsAndUpdateId(arr) {
            return arr
                .filter(item => {
                    const keys = Object.keys(item);
                    // 检查除了 id 以外的键是否都为空
                    for (let key of keys) {
                        if (key !== "id" && item[key] !== "") {
                            return true;
                        }
                    }
                    return false;
                })
                .map((item, index) => {
                    // 更新 id 为当前下标加 1
                    return {
                        ...item,
                        id: index + 1
                    };
                });
        },
        save(i) {
            this.dataInfo.budgetDetail = this.removeEmptyObjectsAndUpdateId(this.dataInfo.budgetDetail)
            this.dataInfo.progressPlan = this.removeEmptyObjectsAndUpdateId(this.dataInfo.progressPlan)
            if (i == 1) {
                //
                if (this.dataInfo.cooperativeUnit[0].name === "") {
                    this.$message.warn("请填写协作单位（至少一条）");
                    return;
                }
                if (this.dataInfo.progressPlan[0].content === "" || this.dataInfo.progressPlan[0].startTime === "" || this.dataInfo.progressPlan[0].endTime === "") {
                    this.$message.warn("请填写项目实施进度计划（至少一条）");
                    return;
                }
                if (this.dataInfo.budgetDetail[0].money === "" || this.dataInfo.budgetDetail[0].purpose === "" || this.dataInfo.budgetDetail[0].spending === "") {
                    this.$message.warn("请填写具体预算此处填写申报经费的明细（至少一条）");
                    return;
                }

                if (this.dataInfo.projectBrief == "") {
                    this.$message.warn("请填写项目简介");
                    return;
                }
                if (this.dataInfo.projectName == "") {
                    this.$message.warn("请填写项目名称");
                    return;
                }
                if (this.dataInfo.unitName == "") {
                    this.$message.warn("请填写申报单位");
                    return;
                }
                // creditCode: "",//统一社会信用代码
                if (this.dataInfo.creditCode == "") {
                    this.$message.warn("请填写统一社会信用代码");
                    return;
                }

                if (this.dataInfo.decEntrance == "") {
                    this.$message.warn("请填写登陆入口");
                    return;
                }
                if (this.dataInfo.unitType == "") {
                    this.$message.warn("请选择单位类别");
                    return;
                }
                if (this.dataInfo.projectLeader == "") {
                    this.$message.warn("请填写项目负责人");
                    return;
                }
                if (this.dataInfo.projectLeaderPhone == "") {
                    this.$message.warn("请填写联系电话");
                    return;
                }
                if (this.dataInfo.financeAccount == "") {
                    this.$message.warn("请填写财务账号名称");
                    return;
                }
                if (this.dataInfo.financeBankAddress == "") {
                    this.$message.warn("请填写开户行及账号");
                    return;
                }
                if (this.dataInfo.projectType == "") {
                    this.$message.warn("请选择项目类别");
                    return;
                }
                if (this.dataInfo.projectForm == "") {
                    this.$message.warn("请填写项目呈现形式");
                    return;
                }
                if (this.dataInfo.planSource == "") {
                    this.$message.warn("请选择策划来源");
                    return;
                }
                if (this.dataInfo.setupTime == "") {
                    this.$message.warn("请填写项目开展时间");
                    return;
                }
                if (this.dataInfo.isFundsSource == "") {
                    this.$message.warn("请选择是否已获得本单位或本地区配套经费支持");
                    return;
                } else {
                    if (this.dataInfo.isFundsSource == "是") {
                        if (this.dataInfo.fundsSource === '') {
                            this.$message.warn("请选择输入配套金额（万元）");
                            return;
                        }
                    }

                }
                if (this.dataInfo.activityPersonExtra == "") {
                    this.$message.warn("请选择活动受众人群");
                    return;
                }
                if (
                    this.dataInfo.activityPersonExtra == "其他" &&
                    this.dataInfo.specificPopulation == ""
                ) {
                    this.$message.warn("请填写具体人群");
                    return;
                }
                if (this.dataInfo.personNumber == "") {
                    this.$message.warn("请填写受众人数");
                    return;
                }
                if (this.dataInfo.continuousContent == "") {
                    this.$message.warn("请选择是否已成为持续性项目");
                    return;
                }
                if (
                    this.dataInfo.continuousContent == "是" &&
                    this.dataInfo.supplementaryMaterial == ""
                ) {
                    this.$message.warn("请填写和上传前期成果与影响佐证材料");
                    return;
                }
                if (
                    this.dataInfo.continuousContent == "是" &&
                    this.dataInfo.fileList.length == 0
                ) {
                    this.$message.warn("请上传前期成果与影响佐证材料");
                    return;
                }
                if (this.dataInfo.introduction == "") {
                    this.$message.warn("请填写申请单位概况");
                    return;
                }
                if (this.dataInfo.innovation == "") {
                    this.$message.warn("请填写项目立项依据");
                    return;
                }
                if (this.dataInfo.target == "") {
                    this.$message.warn("请填写项目预期目标");
                    return;
                }

            }

            this.createdecInformation(i);
        },
        handleChange() {
        },
        uploadSelect(file) {
            const isPDFIMG = file.type === 'application/pdf' || file.type === 'image/jpeg';
            var form = new FormData();
            form.append("multipartFile", file);
            if (!isPDFIMG) {
                this.$message.error(`${file.name} 不符合上传要求，请重新上传！`);
            } else {
                openUploadApi(form).then((res) => {
                    console.log(res);
                    this.dataInfo.fileList.push({
                        url: res.data,
                        name: file.name,
                    });
                });
            }
        },
        uploaderCoverUrlOne(option) {
            if (this.dataInfo.fileList.length >= 5) {
                this.$message.warn("最多只能上传5条佐证材料");
                return;
            }

            console.log((option.file.size / 1000 / 1000).toFixed(1));
            if ((option.file.size / 1000 / 1000).toFixed(1) > 5) {
                this.$message.warn("单个文件大小不能超过5M");
                return;
            }
            this.spinning = true;
            this.uploadSelect(option.file)
            this.spinning = false;
        },
        preview(val) {
            if (val.url.indexOf("https") < 0) {
                val.url = val.url.replace("http", "https");
            }

            console.log(val);
            if (val.name.indexOf("pdf") > -1) {
                let url = `https://storage.tmtsp.com/pdfjs/html_pdf/index.html?file=${val.url}`;
                window.open(url);
            } else {
                window.open(val.url);
            }
        },
        removeFile(val, i) {
            this.dataInfo.fileList.splice(i, 1);
        },
        cancel() {
            this.$emit("goProject", this.chooseType);
        },
        clearData() {
            this.saveStatus = 0;
            this.declareStatus = 0;
            this.dataInfo.projectName = "";
            this.dataInfo.setupTime = "";
            this.dataInfo.unitType = "";
            this.dataInfo.projectLeader = "";
            this.dataInfo.financeAccount = "";
            this.dataInfo.financeBankAddress = "";
            this.dataInfo.projectForm = "";
            this.dataInfo.projectLeaderPhone = "";
            this.dataInfo.introduction = "";
            this.dataInfo.target = "";
            this.dataInfo.innovation = "";
            this.dataInfo.projectBrief = "";

            this.dataInfo.personNumber = "";
            this.dataInfo.projectType = "";
            this.dataInfo.subsidizeType = "特色品牌项目";
            this.dataInfo.fundsSource = "";
            this.dataInfo.planSource = "";
            this.dataInfo.activityPersonExtra = "";
            this.dataInfo.specificPopulation = "";
            this.dataInfo.continuousContent = "";
            this.dataInfo.supplementaryMaterial = "";
            this.dataInfo.cityOpinion = "";
            this.dataInfo.provinceOpinion = "";
            this.dataInfo.expertOpinion = "";
            this.fileUrl = "";
            this.dataInfo.fileList = [];
            this.newToTarget = "";

            // 预算明细
            this.dataInfo.budgetDetail = [
                {
                    id: 1,
                    spending: "",
                    money: "",
                    purpose: '',
                },
                {
                    id: 2,
                    spending: "",
                    money: "",
                    purpose: '',
                },
                {
                    id: 3,
                    spending: "",
                    money: "",
                    purpose: '',
                },
                {
                    id: 4,
                    spending: "",
                    money: "",
                    purpose: '',
                },
            ]
            // 项目实施进度计划
            this.dataInfo.progressPlan = [
                {
                    content: '',
                    startTime: '',
                    endTime: '',
                },
                {
                    content: '',
                    startTime: '',
                    endTime: '',
                },
                {
                    content: '',
                    startTime: '',
                    endTime: '',
                },
                {
                    content: '',
                    startTime: '',
                    endTime: '',
                },
                {
                    content: '',
                    startTime: '',
                    endTime: '',
                },
            ]
            // 协作单位
            this.dataInfo.cooperativeUnit = [
                {
                    id: 1,
                    name: ''
                },
                {
                    id: 2,
                    name: ''
                },
                {
                    id: 3,
                    name: ''
                },
                {
                    id: 4,
                    name: ''
                },
            ]
        },
    },
    created() {
        console.log(this.$route);

        this.routerKey = this.$route.path;
        console.log(this.routerKey);
        console.log(this.routerKey.indexOf("declarationCenter") > -1);
        if (localStorage.getItem("userModel")) {
            this.userTypeValue = JSON.parse(
                localStorage.getItem("userModel")
            ).userType;
        }
        if (localStorage.getItem("userModel")) {
            let obj = JSON.parse(localStorage.getItem("userModel"));
            console.log("outInput=>ob======================j", obj);
            this.dataInfo.unitName = obj.unitName;
            this.dataInfo.decEntrance = obj.decEntrance;
        }

        // 数据清空
        if (!sessionStorage.getItem("declareInfo")) {
            this.clearData()


        } else {
            // 回显
            let declareInfoObj = JSON.parse(sessionStorage.getItem("declareInfo"));
            let extraInfo = JSON.parse(declareInfoObj.extraInfo)
            console.log("outInput=>extraInfo", extraInfo);
            this.dataInfo.creditCode = extraInfo.creditCode
            this.dataInfo.cooperativeUnit = extraInfo.cooperativeUnit
            this.dataInfo.setupTime = extraInfo.setupTime
            this.dataInfo.isFundsSource = extraInfo.isFundsSource
            this.dataInfo.fundsSource = extraInfo.fundsSource
            this.dataInfo.target = extraInfo.target
            this.dataInfo.progressPlan = extraInfo.progressPlan
            this.dataInfo.budgetDetail = extraInfo.budgetDetail
            console.log(declareInfoObj);
            console.log("outInput=>--------------------");
            this.newToTarget = declareInfoObj.toTarget;
            this.dataInfo.projectName = extraInfo.projectName;
            this.dataInfo.unitType = extraInfo.unitType;
            this.dataInfo.projectLeader = extraInfo.projectLeader;
            this.dataInfo.financeBankAddress = extraInfo.financeBankAddress;
            this.dataInfo.financeAccount = extraInfo.financeAccount;
            this.dataInfo.projectForm = extraInfo.projectForm;
            this.dataInfo.projectLeaderPhone = extraInfo.projectLeaderPhone;
            this.dataInfo.introduction = extraInfo.introduction;
            this.dataInfo.innovation = extraInfo.innovation;
            this.dataInfo.projectBrief = extraInfo.projectBrief;
            this.dataInfo.budget = extraInfo.budget;
            this.dataInfo.personNumber = extraInfo.personNumber;
            this.dataInfo.projectType = extraInfo.projectType;
            this.dataInfo.subsidizeType = extraInfo.subsidizeType;
            this.dataInfo.fundsSource = extraInfo.fundsSource;
            this.dataInfo.planSource = extraInfo.planSource;
            this.dataInfo.activityPersonExtra = extraInfo.activityPersonExtra;
            this.dataInfo.specificPopulation = extraInfo.specificPopulation;
            this.dataInfo.supplementaryMaterial = extraInfo.supplementaryMaterial;
            this.dataInfo.continuousContent = extraInfo.continuousContent;
            this.dataInfo.cityOpinion = extraInfo.cityOpinion;
            this.dataInfo.provinceOpinion = extraInfo.provinceOpinion;
            this.dataInfo.expertOpinion = declareInfoObj.expertOpinion;
            this.dataInfo.unitName = extraInfo.unitName;
            this.dataInfo.decEntrance = extraInfo.decEntrance;
            this.dataInfo.fileList = extraInfo.fileList;
            this.fileUrl = declareInfoObj.filePath;
            this.declareStatus = declareInfoObj.status;
            this.saveStatus = 1;
        }
        if (this.userTypeValue == 'expert' && this.dataInfo.expertOpinion == "") {
            this.declareStatus = 2;
            this.saveStatus = 2;
        }

    },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
